export const faucetSepolia = [
    {
      title: "Cómo solicitar ETH de prueba en la red Sepolia (Ethereum Testnet) usando la faucet oficial",
      value: `
  Sigue estos pasos detallados para obtener ETH de testnet en la red Sepolia a través de una faucet oficial de Ethereum.  
  No necesitas saldo previo en la mainnet de Ethereum, pero sí es posible que la faucet te pida iniciar sesión o validar que eres una persona real para evitar abusos.
  
  ---
  
  1. **Accede a tu wallet y selecciona la red Sepolia**  
     Abre MetaMask (o tu wallet preferida) y selecciona la red **Sepolia** en la parte superior.  
     Esto es fundamental para que la dirección que copies y pegues sea válida en esta testnet.  
     ![Selecciona la red Sepolia](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/26-1.png)
  
  2. **Copia tu dirección pública**  
     Haz clic en tu dirección (empieza con 0x…) para copiarla al portapapeles.  
     Esta dirección será donde recibirás los ETH de prueba.  
     ![Copia tu dirección Sepolia](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/26-2.png)
  
  3. **Ingresa a una faucet oficial de Sepolia**  
     Puedes usar faucets recomendadas como:  
     - [faucet.sepolia.dev](https://faucet.sepolia.dev/)  
     - [alchemy.com/faucets/ethereum-sepolia](https://www.alchemy.com/faucets/ethereum-sepolia)  
     (Asegúrate de que la faucet sea segura y confiable).
     ![Accede a la faucet de Sepolia](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/26-3.png)
  
  4. **Pega tu dirección en la faucet**  
     Encuentra el campo donde te pide ingresar tu dirección pública y pégala ahí.  
     Algunas faucets pueden pedirte iniciar sesión con GitHub, Google, o realizar un captcha para verificar que eres humano.
     ![Pega tu dirección pública en la faucet](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/26-4.png)
  
  5. **Verifica el Captcha o realiza el login requerido**  
     Marca la casilla "No soy un robot" o completa el paso de autenticación que te pida la faucet.  
     Esto protege los fondos de prueba para que solo lleguen a personas reales y no a bots.
     ![Verifica Captcha](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/26-5.png)
  
  6. **Solicita ETH y espera la confirmación**  
     Haz clic en el botón para solicitar ETH (por ejemplo, "Send Me ETH", "Request", o similar).  
     La página mostrará un mensaje confirmando que tu solicitud fue recibida y, en poco tiempo, te enviará ETH de prueba a tu cuenta Sepolia.
     ![Solicitud exitosa](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/26-6.png)
  
  7. **Revisa tu saldo en MetaMask en la red Sepolia**  
     Vuelve a MetaMask y verifica tu saldo en la red Sepolia.  
     Si no ves el ETH de prueba de inmediato, espera unos minutos y actualiza la wallet.  
     También puedes consultar tu transacción en [Sepolia Etherscan](https://sepolia.etherscan.io/).
     ![Verifica tu saldo en Sepolia](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/26-7.png)
  
  ---
  
  **¿Por qué usar ETH de prueba en Sepolia?**  
  El ETH de testnet **no tiene valor real**. Sirve únicamente para desplegar contratos, practicar transacciones y aprender a operar en la blockchain sin ningún riesgo económico.  
  El uso de faucets oficiales ayuda a mantener la red abierta para todos y reduce el abuso de recursos.
  
   ![Verifica tu saldo en Sepolia](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/26-8.png)
   
   ¡Listo! Ya tienes ETH de prueba en Sepolia y puedes comenzar a experimentar en esta testnet de Ethereum.
  `
    }
  ];
  
  export default faucetSepolia;
  